import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';

import { getFullAccessActionName, FULL_ACCESS_ACTION_NAMES } from 'widget/ui-selectors/video-access';
import { getChannelForWidget } from 'shared/selectors/channels';
import { getCurrentSiteUser } from 'widget/selectors/current-site-user';
import { isExternalVideo } from 'shared/ui-selectors/video/video-origin';
import getVideoUrls from 'widget/selectors/get-video-urls';

import { openBuyVideoOverlay } from 'widget/redux/client/actions/mobile-overlay-openners/payment-pages-actions';
import { openVideoPage } from 'widget/redux/client/actions/mobile-overlay-openners/main-openners';

import { PlayerCover } from 'widget/components/player-cover/player-cover';
import ThreeRowsWidgetOverlay from 'widget/components/player-overlay/mobile/three-rows-widget/three-rows-widget';

import styles from './mobile-cover-with-overlay.styl';


@connect(
  (state, props) => ({
    channelData: getChannelForWidget(state),
    currentSiteUser: getCurrentSiteUser(state),
    videoUrls: getVideoUrls(state, props),
  }),
  (dispatch, { videoItem }) => ({
    onBuyVideoClick: () => dispatch(openBuyVideoOverlay(videoItem.id)),
    onOpenVideoClick: () => dispatch(openVideoPage(videoItem.id)),
  })
)
export default class CoverWithOverlay extends React.Component {

  static propTypes = {
    channelData: React.PropTypes.object,
    canShowChannelCover: React.PropTypes.bool,
    onBuyVideoClick: React.PropTypes.func,
    onOpenVideoClick: React.PropTypes.func,
    onSignInRequested: React.PropTypes.func,

    videoItem: React.PropTypes.object,
    showChannelCover: React.PropTypes.bool,
    className: React.PropTypes.string,
    itemWidth: React.PropTypes.number,
    itemHeight: React.PropTypes.number,
    currentSiteUser: React.PropTypes.object,
    onPlayClick: React.PropTypes.func,
    onMemberSignUp: React.PropTypes.func,
    videoUrls: React.PropTypes.object,
  };

  @autobind
  onPlayClick() {
    const {
      onPlayClick,
      channelData,
      videoItem,
      currentSiteUser,
      onMemberSignUp,
      videoUrls,
    } = this.props;

    const accessActionName = getFullAccessActionName(channelData, videoItem, currentSiteUser);

    if (accessActionName === FULL_ACCESS_ACTION_NAMES.SIGN_IN) {
      onMemberSignUp();
      return;
    }

    if (!videoUrls && !isExternalVideo(videoItem)) {
      return;
    }

    onPlayClick();
  }

  render() {
    const {
      videoItem,
      showChannelCover,
      onOpenVideoClick,
      onBuyVideoClick,
      onSignInRequested,
      itemWidth,
      itemHeight,
      className,
    } = this.props;

    return (
      <PlayerCover videoItem={videoItem}
                   className={className}
                   coverWidth={itemWidth}
                   coverHeight={itemHeight}
                   showChannelCover={showChannelCover}>
        <ThreeRowsWidgetOverlay videoItem={videoItem}
                                className={styles['slidable-overlay']}
                                showChannelCover={showChannelCover}
                                onSignInRequested={onSignInRequested}
                                onOpenVideoClick={onOpenVideoClick}
                                onBuyVideoClick={onBuyVideoClick}
                                onPlayClick={this.onPlayClick} />
      </PlayerCover>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/cover-with-overlay/mobile-cover-with-overlay.js